import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import HandshakeIcon from "@mui/icons-material/Handshake";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import DashboardIcon from "@mui/icons-material/Home";
import ChatIcon from "@mui/icons-material/Chat";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import Workspaces from "@mui/icons-material/Workspaces";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupIcon from "@mui/icons-material/Group";

const WhiteIcon = styled(Box)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  fontSize: "1.5rem",
  marginLeft: "7px",
  marginBottom: "9px",
  transition: "transform 0.2s ease",
  "&:hover": {
    transform: "scale(1.1)",
  },
}));

export interface NavigationItem {
  label: string;
  to: string;
}

export interface NavItemsProps {
  items: NavigationItem[];
  isExpanded: boolean;
}

export type UserRole =
  | "Developer"
  | "BA"
  | "Brand"
  | "Supplier"
  | "Account"
  | "Agency";

export const navigationConfig: Record<UserRole, NavigationItem[]> = {
  Developer: [
    { label: "Home", to: "/" },
    { label: "Users", to: "/manage-users" },
    { label: "Analytics", to: "/analytics" },
    { label: "Settings", to: "/settings" },
  ],
  BA: [
    { label: "Home", to: "/" },
    { label: "Leaderboard", to: "/leaderboard" },
    { label: "Analytics", to: "/analytics" },
    { label: "Settings", to: "/settings" },
  ],
  Brand: [
    { label: "Home", to: "/" },
    { label: "Event Center", to: "/event-center" },
    { label: "Analytics", to: "/analytics" },
    { label: "Raven AI", to: "/RavenAI" },
    { label: "Settings", to: "/settings" },
  ],
  Supplier: [
    { label: "Home", to: "/" },
    { label: "Event Center", to: "/event-center" },
    { label: "Raven AI", to: "/RavenAI" },
    { label: "Analytics", to: "/analytics" },
    { label: "Settings", to: "/settings" },
  ],
  Account: [
    { label: "Home", to: "/" },
    { label: "Analytics", to: "/analytics" },
    { label: "Settings", to: "/settings" },
  ],
  Agency: [
    { label: "Home", to: "/" },
    { label: "Event Center", to: "/event-center" },
    { label: "Staff", to: "/Staff" },
    { label: "Analytics", to: "/analytics" },
    { label: "Settings", to: "/settings" },
  ],
};

const getIconForLabel = (label: string) => {
  switch (label) {
    case "Home":
      return <DashboardIcon />;
    case "Available Events":
    case "Event Center":
      return <CiCalendar />;
    case "Messages":
      return <ChatIcon />;
    case "Settings":
      return <SettingsApplicationsIcon />;
    case "Brand Pitches":
      return <HandshakeIcon />;
    case "Raven AI":
      return <AutoAwesomeIcon />;
    case "Staff":
      return <Workspaces />;
    case "Analytics":
      return <AnalyticsIcon />;
    case "Leaderboard":
      return <EmojiEventsIcon />;
    case "Users":
      return <GroupIcon />;
    default:
      return <DashboardIcon />;
  }
};

const NavItems: React.FC<NavItemsProps> = ({ items, isExpanded }) => {
  return (
    <>
      {items.map((item, index) => (
        <ListItem key={index} disablePadding>
          <ListItemButton component={Link} to={item.to}>
            <ListItemIcon>
              <WhiteIcon>{getIconForLabel(item.label)}</WhiteIcon>
            </ListItemIcon>
            {isExpanded && <ListItemText primary={item.label} />}
          </ListItemButton>
        </ListItem>
      ))}
    </>
  );
};

export default NavItems;
